import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const { Column } = Table;


export default class CarteirasClientesProdutosForm extends Component {
  state = {
    listaRegistros: [],
    carregandoForm: false,
    visualizando: false,

  };


  componentDidUpdate(propsAnterior) {
    // console.log('CarteirasClientesProdutosForm.componentDidUpdate---------------------------------: ', this.props);
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        listaRegistros: this.props.registroSelecionado,
      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };




  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderValorUN1 = (vlr, registro) => {
    return (
      <span> {numeral(registro.vlrItens / registro.qtdeItens).format('0,000.00')} </span>
    );
  };


  renderValorUN2 = (vlr, registro) => {
    return (
      <span> {registro.qtdeItens2 ? numeral(registro.vlrItens / registro.qtdeItens2).format('0,000.00') : ''} </span>
    );
  };






  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoForm, listaRegistros } = this.state;

    // console.log('CarteirasClientesProdutosForm.this.state: ', this.state);

    return (
      <Modal
        title={"Produtos do Cliente"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"70%"}
        style={{ top: 10 }}
      >

        <div style={{ height: 450 }}>
          <Table
            pagination={false}
            onChange={this.onTabelaChange}
            dataSource={listaRegistros}
            scroll={{ y: 420 }}
            rowKey={(registro => registro.pes_codigo)}
          >
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title="Produto"
              width={"5%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title="Descrição do Produto"
              width={"20%"}
              align="left"
              className="listaCadastro"
            />

            <Column
              key="qtdeItens"
              dataIndex="qtdeItens"
              title="Qtde Vendida 1"
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="med_descricao1"
              dataIndex="med_descricao1"
              title="UN 1"
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="vlrItens"
              dataIndex="vlrItens"
              title="Valor Unit 1"
              render={this.renderValorUN1}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="qtdeItens2"
              dataIndex="qtdeItens2"
              title="Qtde Vendida 2"
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="med_descricao2"
              dataIndex="med_descricao2"
              title="UN 2"
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="vlrItens1"
              dataIndex="vlrItens1"
              title="Valor Unit 2"
              render={this.renderValorUN2}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="vlrItens"
              dataIndex="vlrItens"
              title="Valor Total"
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            
          </Table>
        </div>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CarteirasClientesProdutosForm.js